module.exports = __webpack_public_path__ + "img/b893ef6.webp";